<template>
  <div>
    
    {{ showValue }}
  </div>
</template>

<script>
import { getRecordById } from "../builder/base.js";

export default {
  components: {},
  props: {
    cellData: {
      type: Object,
      default: () => {},
    },
    currentRoute: String,
    fieldDef: {
      type: Object,
      default: () => ({}),
    },
    value: String,
    prefix: String,
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
  },
  data: function () {
    return {
      rowValue: "",
      oldValue: "",
      showValue: "",
    };
  },
  methods: {
    getById() {
      console.log("ListRelateFieldShow getById ", this.fieldDef);

      getRecordById(
        "/" +
          this.prefix +
          "/" +
          this.fieldDef.editorOptions.relateModule +
          "/getById/" +
          this.rowValue
      ).then((response) => {
        this.showValue = response.data.data.name;
      });

      /* let data = "";
                
            let rs = axios.get(
                  "/"+this.prefix+"/"+this.fieldDef.editorOptions.relateModule+'/getById',
                  {
                    params: {
                        id: this.rowValue
                    }
                  }                  
                );

            rs.then(response => {
                console.log(response.data.data.name);
                this.showValue =  response.data.data.name; 
            });   */

      //this.showValue =  data;
    },
  },
  created() {
    //console.log("created",this.cellData.value);
  },
  mounted() {
    console.log("mounted ListRelate Cell Data", this.cellData);
    this.rowValue = this.cellData.value;
    if (this.cellData.value) {
      // 👇️ this runs

      this.getById();
      /* if(this.rowValue != this.oldValue)
            {   
                
                this.oldValue = this.rowValue;
            } */
    }
  },
};
</script>

<style>
</style>